import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faCheck } from '@fortawesome/free-solid-svg-icons';
import { products } from '../data/products';
import '../styles/ProductDetailPage.css';

const ProductDetailPage = () => {
  const { slug } = useParams();
  const product = products.find((item) => item.slug === slug);

  if (!product) {
    return (
      <div className="product-detail-page product-not-found">
        <div className="container">
          <h1>Ürün bulunamadı</h1>
          <Link to="/products" className="back-products-link">
            <FontAwesomeIcon icon={faArrowLeft} />
            Ürünlere Dön
          </Link>
        </div>
      </div>
    );
  }

  const titleParts = product.name.split(' ');
  const goldTitle = titleParts.slice(0, 2).join(' ');
  const blackTitle = titleParts.slice(2).join(' ');

  return (
    <div className="product-detail-page">
      <section className="product-sheet">
        <div className="container">
          <Link to="/products" className="back-products-link">
            <FontAwesomeIcon icon={faArrowLeft} />
            Ürünlere Dön
          </Link>

          <div className="product-sheet-grid">
            <motion.div
              className="product-title-block"
              initial={{ opacity: 0, x: -24 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.55 }}
            >
              <div className="product-sheet-title">
                <span>{goldTitle}</span>
                {blackTitle && <strong>{blackTitle}</strong>}
              </div>
              <p className="product-lead">{product.description}</p>
            </motion.div>

            <motion.div
              className="product-visual-card"
              initial={{ opacity: 0, x: 24 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.55, delay: 0.1 }}
            >
              <img src={product.image} alt={product.name} />
            </motion.div>

            <motion.div
              className="advantages-block"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.55, delay: 0.12 }}
            >
              <h2>Avantajları</h2>
              <ul>
                {product.advantages.map((advantage) => (
                  <li key={advantage}>
                    <span className="check-icon">
                      <FontAwesomeIcon icon={faCheck} />
                    </span>
                    {advantage}
                  </li>
                ))}
              </ul>
            </motion.div>

            <motion.div
              className="technical-specs-block"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.55, delay: 0.18 }}
            >
              <h2>Teknik Özellikler</h2>
              <dl>
                {product.specs.map(([label, value]) => (
                  <div className="spec-row" key={label}>
                    <dt>{label}</dt>
                    <dd>{value}</dd>
                  </div>
                ))}
              </dl>
            </motion.div>

            <motion.div
              className="technical-detail-card"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.55, delay: 0.22 }}
            >
              <h2>Teknik Detay</h2>
              <div className="profile-diagram">
                <span className="dimension dimension-height left">{product.detail.height}</span>
                <span className="dimension dimension-height right">{product.detail.height}</span>
                <span className="dimension dimension-width">{product.detail.width}</span>
                <div className="profile-shape">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProductDetailPage;
